import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames'
import _ from 'lodash'
import { compose } from 'recompose'

import * as ROLES from '../../../constants/roles'
import IfAnyGranted from '../route-management/IfAnyGranted'
import LangSelect from '../lang-select/LangSelect'
import NavbarItemUser from './NavbarItemUser'
import { withTranslation } from 'react-i18next'

class Navbar extends React.Component {
  state = {
    isActive: false,
  }

  menuToggle = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }))
  }

  render() {
    const { i18n } = this.props

    return (
      <nav className="navbar is-transparent is-fixed-top">
        <div className="navbar-brand">
          <Link className="navbar-item" to={`/menu`}>
            <strong> {i18n.t('home.label')} </strong>
          </Link>
          <IfAnyGranted roles={[ROLES.ADMIN, ROLES.SUPERVISOR]}>
            <Link
              className={classNames('navbar-item', {
                'is-active': _.chain(this.props)
                  .get('match.path')
                  .includes('towns')
                  .value(),
              })}
              to={`/towns`}
            >
              <span> {i18n.t('town.label')} </span>
            </Link>
          </IfAnyGranted>
          <Link
            className={classNames('navbar-item', {
              'is-active': _.chain(this.props)
                .get('match.path')
                .includes('portals')
                .value(),
            })}
            to={`/portals`}
          >
            <span> {i18n.t('portal.label')}</span>
          </Link>
          <Link
            className={classNames('navbar-item', {
              'is-active': _.chain(this.props)
                .get('match.path')
                .includes('contributor')
                .value(),
            })}
            to={`/contributor`}
          >
            <span> {i18n.t('contributor.label')} </span>
          </Link>

          <a
            onClick={this.menuToggle}
            role="button"
            className={classNames('navbar-burger burger', {
              'is-active': this.state.isActive,
            })}
            aria-label="menu"
            aria-expanded="false"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>
        <div
          className={classNames('navbar-menu', {
            'is-active': this.state.isActive,
          })}
        >
          <div className="navbar-end">
            <div className="navbar-item">
              <div className="field is-grouped">
                <LangSelect />
              </div>
            </div>
            <NavbarItemUser />
          </div>
        </div>
      </nav>
    )
  }
}

export default compose(
  withTranslation(),
  withRouter,
)(Navbar)



// WEBPACK FOOTER //
// ./src/components/templates/navbar/Navbar.js